import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScenarioCostTasks = api(async function scenarioCostTasks({
    scenarioId,
    variantId,
    setKey,
    first,
    after,
    resolution,
    conditionKeys,
}) {
    return query(
        gql`
            query GetScenarioCostTasks(
                $scenarioId: String!
                $variantId: String!
                $setKey: String!
                $first: Int
                $after: String
                $resolution: String
                $conditionKeys: [String!]
            ) {
                scenarioCostTasks(
                    scenarioId: $scenarioId
                    variantId: $variantId
                    setKey: $setKey
                    first: $first
                    after: $after
                    resolution: $resolution
                    conditionKeys: $conditionKeys
                ) {
                    items
                    endCursor
                    hasNextPage
                    totalCount
                    conditionOptions
                }
            }
        `,
        { scenarioId, variantId, setKey, first, after, resolution, conditionKeys },
        { returns: "scenarioCostTasks" }
    )
})
